'use client'
import { type FC, memo, useRef } from 'react'
import styled from 'styled-components'
import { designGrid, mq, vw, font12, getVariants } from '@/styles'
import { motion, useInView } from 'motion/react'

type Props = {
  title: string
}

export const HeaderContents:FC<Props> = memo(({ title }) => {
  const ref = useRef<HTMLDivElement>(null)
	const isInView = useInView(ref, { margin: '0px', once: true })

  return (
    <Header ref={ref} variants={getVariants(isInView)} initial='initial' animate='animate' exit='exit'>
      <h1 className='srt-only'>{title}</h1>
    </Header>
  )
})

const Header = styled(motion.header)`
  ${designGrid({})}
	display: none;
  padding: ${vw(50, 'mobile')} 0;
  grid-column: 1 / span 6;

  ${mq.greaterThan('tablet')} {
    padding: ${vw(70, 'desktop')} 0;
    grid-column: 1 / span 12;
  }

  ${mq.greaterThan('desktop')} {
    padding: 70px 0;
  }

  h1 {
    ${font12(true, 400)}
    grid-column: 1 / span 6;
    text-transform: uppercase;

    ${mq.greaterThan('tablet')} {
      ${font12(false, 400)}
      grid-column: 1 / span 12;
    }
  }
`
